export default __webpack_public_path__ + "static/media/nav_img_02.71e6af5f.png";